module.exports = __webpack_public_path__ + "static/media/DSC_0040.14d0b46a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0040.jpg
// module id = 621
// module chunks = 0